let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8JWF2")).then(() => parcelRequire('9LjTG'));